// @flow
import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

import './skeleton.scss'

function ListSkeleton({ className, header }) {
  return (
    <div className={`list-skeleton ${className}`}>
      {header && (
        <div className="list-skeleton__hd">
          <div className="skeleton-cell__item">
            <Skeleton height={30} />
          </div>
          <div className="skeleton-cell__item">
            <Skeleton height={30} />
          </div>
        </div>
      )}
      <div className="skeleton-cells">
        {[1, 2, 3, 4, 5, 6].map(key => (
          <div key={key} className="skeleton-cell">
            <div className="skeleton-cell__title">
              <Skeleton height={25} width={300} />
            </div>
            <div className="skeleton-cell__desc">
              <span className="skeleton-cell__item">
                <Skeleton height={20} width={50} />
              </span>
              <span className="skeleton-cell__item">
                <Skeleton height={20} width={50} />
              </span>
              <span className="skeleton-cell__item">
                <Skeleton height={20} width={50} />
              </span>
            </div>
            <div className="skeleton-cell__desc">
              <span className="skeleton-cell__item">
                <Skeleton height={20} width={150} />
              </span>
            </div>
            <div className="skeleton-cell__desc">
              <span className="skeleton-cell__item">
                <Skeleton height={20} width={150} />
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

ListSkeleton.propTypes = {
  className: PropTypes.string,
  header: PropTypes.bool
}

function PostcardSkeleton() {
  return (
    <div className="skeleton-cell">
      <div className="skeleton-cell__title">
        <Skeleton height={25} width={300} />
      </div>
      <div className="skeleton-cell__desc">
        <span className="skeleton-cell__item">
          <Skeleton height={20} width={50} />
        </span>
        <span className="skeleton-cell__item">
          <Skeleton height={20} width={50} />
        </span>
        <span className="skeleton-cell__item">
          <Skeleton height={20} width={50} />
        </span>
      </div>
      <div className="skeleton-cell__desc">
        <span className="skeleton-cell__item">
          <Skeleton height={20} width={150} />
        </span>
      </div>
      <div className="skeleton-cell__desc">
        <span className="skeleton-cell__item">
          <Skeleton height={20} width={150} />
        </span>
      </div>
    </div>
  )
}

function Details() {
  return (
    <div className="details-skeleton">
      <div className="details-skeleton__title">
        <Skeleton height={30} />
      </div>
      <div className="details-skeleton__info">
        <div className="skeleton-cell">
          <div className="skeleton-cell__title">
            <Skeleton height={25} width={300} />
          </div>
          <div className="skeleton-cell__desc">
            <span className="skeleton-cell__item">
              <Skeleton height={20} width={50} />
            </span>
            <span className="skeleton-cell__item">
              <Skeleton height={20} width={50} />
            </span>
            <span className="skeleton-cell__item">
              <Skeleton height={20} width={50} />
            </span>
          </div>
          <div className="skeleton-cell__desc">
            <span className="skeleton-cell__item">
              <Skeleton height={20} width={150} />
            </span>
          </div>
        </div>
      </div>
      <div className="details-skeleton__info">
        <Skeleton height={400} />
      </div>
      <div className="details-skeleton__info">
        <Skeleton height={40} />
      </div>
    </div>
  )
}

function Login() {
  return (
    <div className="login-skeleton">
      <div className="login-skeleton__from">
        <div className="login-skeleton__from-cell">
          <Skeleton height={40} />
        </div>
        <div className="login-skeleton__from-cell">
          <Skeleton height={40} />
        </div>

        <div className="login-skeleton__from-action">
          <Skeleton height={40} />
        </div>
      </div>
    </div>
  )
}

function Resume() {
  return (
    <div className="resume-skeleton">
      <div className="resume-skeleton__header">
        <Skeleton height={44} width={350} />
      </div>
      {[1, 2, 3, 4, 5, 6].map(item => (
        <div className="resume-skeleton__item" key={item}>
          <div className="resume-skeleton__title">
            <Skeleton height={22} width={52} />
          </div>
          <div className="resume-skeleton__desc">
            <Skeleton height={22} width={300} />
          </div>
          <div className="resume-skeleton__desc">
            <Skeleton height={22} width={300} />
          </div>
        </div>
      ))}
    </div>
  )
}

function InformationDetailSkeleton() {
  return (
    <div className="details-skeleton">
      <div className="details-skeleton__title">
        <Skeleton height={30} />
      </div>
      <div className="details-skeleton__info">
        <div className="skeleton-cell">
          <div className="skeleton-cell__title">
            <Skeleton height={25} width={100} />
          </div>
          <div className="skeleton-cell__desc">
            <span className="skeleton-cell__item">
              <Skeleton height={50} width={350} />
            </span>
          </div>
        </div>
      </div>
      <div className="details-skeleton__info">
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
        <Skeleton height={25} />
      </div>
      <div className="details-skeleton__info">
        <Skeleton height={25} width={100} />
      </div>
      <div className="details-skeleton__info">
        <Skeleton height={25} width={350} />
        <Skeleton height={25} width={350} />
        <Skeleton height={25} width={350} />
      </div>
    </div>
  )
}

const skeletonMaps = {
  '/': <ListSkeleton header />,
  '/details': <Details />,
  '/example': <Skeleton height={25} />,
  '/login': <Login />,
  '/search': <ListSkeleton />,
  '/record': <ListSkeleton />,
  '/resume': <Resume />
}

export default function PageSkeleton(props) {
  const { location } = props

  const renderSkeleton = () => {
    if (skeletonMaps[location.pathname]) {
      return skeletonMaps[location.pathname]
    }

    return <Skeleton height={25} />
  }
  return <div className="skeleton-container">{renderSkeleton()}</div>
}

export { PostcardSkeleton, ListSkeleton, InformationDetailSkeleton }
PageSkeleton.defaultProps = {
  location: null
}
PageSkeleton.propTypes = {
  location: PropTypes.object
}
